export const username = state => state.user.username;
export const oldPassword = state => state.user.oldPassword;
export const isAdmin = state => state.isAdmin;
export const user = state => state.user;
